// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"a3-z","colorTextValue":"b3-z","swatches":"c3-z","collapseLink":"d3-z","isCollapsed":"e3-z","dropdown":"f3-z","disabled":"g3-z"};